export const getOperation = increaseValue => {
  const operation = increaseValue > 0 ? 'increased' : 'decreased';
  return operation;
};
